//@ts-ignore
import { dinero, Dinero, toDecimal } from 'dinero.js';
import { Currency, DKK, EUR, ISK, NOK, USD } from '@dinero.js/currencies';

//TODO VALIDATE THIS NEW CODE
export const currencyFormat = (
    amount: number,
    currency: Currency<number>,
    locale: string,
) => {
    return intlCurrencyFormat(
        dinero({
            amount: amount,
            currency: currency,
        }),
        locale,
    );
};

const intlCurrencyFormat = (
    dineroObject: Dinero<number>,
    locale: string,
    options = {},
) => {
    function transformer({
        value,
        currency,
    }: {
        value: string;
        currency: any;
    }) {
        return Number(value).toLocaleString(locale, {
            ...options,
            style: 'currency',
            currency: currency.code,
        });
    }

    //TODO do this better
    return toDecimal(dineroObject, transformer); // "USD 50.00"
};

export const qtyFormater = (qty: number) => {
    if (qty % 1 === 0) {
        return Math.round(qty);
    }
    return qty.toFixed(1);
};
export const toMinorPrice = (majorPrice: number | null, exponent: number) =>
    (majorPrice ?? 0) * Math.pow(10, exponent);

export const currencies = new Map<string, Currency<number>>([
    ['ISK', ISK],
    ['NOK', NOK],
    ['USD', USD],
    ['DKK', DKK],
    ['EUR', EUR],
]);
